import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import CoreServices from "./CoreServicesReducer";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    coreservices: CoreServices,
  });

export default createRootReducer;
